<template>
  <div class="step">
    <div class="step__container">
      <div class="step__header">
        Oplysninger om
        {{ privateAdFlowProductTypeNames.nameSingularParticular }}
      </div>
      <div class="step__text">
        Her skal du udpege det udstyr din
        {{ privateAdFlowProductTypeNames.nameSingular }} har, beskrive din
        {{ privateAdFlowProductTypeNames.nameSingular }} og uploade billeder af
        {{ privateAdFlowProductTypeNames.nameSingularParticular }}.
      </div>
      <p class="step__section-header">
        <span class="capitalize"
          >{{ privateAdFlowProductTypeNames.nameSingularParticular }}s</span
        >
        udstyr
      </p>
      <div class="step__section">
        <div
          class="step__section-item step__section-item--full-width step__section-item--select"
        >
          <PrivateAdSelect
            class="private-ad-select--inline"
            :title="'Udstyr'"
            :items="listEquipment"
            :search-type="'equipment'"
            :is-disabled="listEquipment.length < 1"
            :event-bus="proxyBus"
            :isUpdate="isUpdate"
            :show-ok-button="true"
            :is-initial-load-prop="false"
          />
        </div>
      </div>
      <p class="step__section-header step__input--required">
        <span
          >Beskriv
          {{ privateAdFlowProductTypeNames.nameSingularParticular }}</span
        >
      </p>
      <p
        class="error"
        v-if="descriptionErrorMessage"
        ref="descriptionErrorContainer"
      >
        <span>{{ descriptionErrorMessage }}</span>
        <span class="error__attention"></span>
      </p>
      <div class="step__section">
        <div class="step__section-item step__section-item--full-width">
          <textarea
            class="step__textarea"
            v-model="description"
            :placeholder="placeholderTextarea"
          ></textarea>
        </div>
      </div>
      <FactBox
        :title="`Beskrivelsen af din ${privateAdFlowProductTypeNames.nameSingular} er vigtig`"
        :body="`Beskriv din ${privateAdFlowProductTypeNames.nameSingular}, ærligt. Det er vigtigt for den interesserede køber at få indsigt i alt det, de ikke kan se umiddelbart på billeder.`"
      />
      <p class="step__section-header step__input--required">
        <span>Overfør billeder</span>
      </p>
      <p
        class="error"
        v-if="imageUploadErrorMessage"
        ref="imageUploadErrorContainer"
      >
        <span>{{ imageUploadErrorMessage }}</span>
        <span class="error__attention"></span>
      </p>
      <div class="step__section-note">
        Overfør ved at trække billeder ind i feltet eller klik på den grønne
        pil. Max 10 Mb pr. billede. Filtyperne jpg, jpeg, gif og png
        understøttes. Rækkefølgen kan ændres ved at trække i billederne.
      </div>
    </div>
    <ImageUpload :event-bus="eventBus" />
    <div class="step__container">
      <FactBox
        :title="'Et billede kan være stærkere end 1000 ord'"
        :body="'Du kan altid tilføje flere billeder på din annonce senere, ved at redigere annoncen under ”mine annoncer”.'"
      />
      <p class="step__section-header">
        <span>Overfør video</span>
      </p>
      <div class="step__section-note">
        Dette kan være en stærk salgsparameter når du skal sælge din
        {{ privateAdFlowProductTypeNames.nameSingular }}. Her kan du fortælle om
        {{ privateAdFlowProductTypeNames.nameSingularParticular }} med dine egne
        ord, gasse op så man kan høre motorlyden, eller vise en 360 graders
        video af {{ privateAdFlowProductTypeNames.nameSingularParticular }}. Du
        kan overføre max én video.
      </div>
      <div class="step__section-note">
        <strong>OBS</strong>: Afhængig af videoens størrelse kan der være lidt
        ventetid før den er klar til visning på din annonce.
      </div>
    </div>
    <VideoUpload
      :video-id="videoId"
      :video-src="videoSrc"
      :event-bus="eventBus"
    />
    <StepButtonPanel
      :event-bus="eventBus"
      :back-visible="true"
      :next-visible="true"
      :next-enabled="true"
      :is-update="isUpdate"
      :validate-function="validate"
    ></StepButtonPanel>
  </div>
</template>
<script>
import { app } from '@/main'
import mitt from 'mitt'

import { decodeHTMLEntities } from '@/functions'
import { scrollToView } from './StepsFunctions'
import FactBox from '@/components/FactBox/FactBox.vue'
import StepButtonPanel from '../Components/StepButtonPanel/StepButtonPanel.vue'
import PrivateAdSelect from '../Components/PrivateAdSelect/PrivateAdSelect.vue'
import ImageUpload from '../Components/ImageUpload/ImageUpload.vue'
import VideoUpload from '../Components/VideoUpload/VideoUpload.vue'

export default {
  components: {
    ImageUpload,
    VideoUpload,
    StepButtonPanel,
    FactBox,
    PrivateAdSelect,
  },
  props: {
    eventBus: { default: null, type: Object },
    listEquipment: { default: null, type: Array },
    vehicleData: {
      default: () => {
        return {}
      },
      type: Object,
    },
    propertyList: {
      default: () => {
        return []
      },
      type: Array,
    },
    privateAdFlowProductTypeNames: {
      default: () => {
        return {}
      },
      type: Object,
    },
    isUpdate: { default: false, type: Boolean },
    videoId: { deafult: '', type: String },
    videoSrc: { deafult: '', type: String },
  },
  data() {
    return {
      activeIndex: null,
      proxyBus: mitt(),
      openStack: [],
      description: '',
      descriptionTimeout: 0,
      propertySelectionOpen: false,
      images: [],
      placeholderTextarea: `Beskriv din ${this.privateAdFlowProductTypeNames.nameSingular} her`,
      mounted: false,

      descriptionErrorMessage: '',
      imageUploadErrorMessage: '',
    }
  },
  methods: {
    validate() {
      let isValid = true
      // Validerer i omvendt rækkefølge for at ramme
      let errorContainer = ''

      if (this.images.length === 0) {
        isValid = false
        this.imageUploadErrorMessage =
          'Læg billeder op af køretøjet (gerne flere billeder)'
        errorContainer = 'imageUploadErrorContainer'
      }
      if (this.description === '') {
        isValid = false
        this.descriptionErrorMessage = 'Beskriv køretøjet du ønsker at sælge'
        errorContainer = 'descriptionErrorContainer'
      }

      if (!isValid) {
        setTimeout(() => {
          scrollToView(this.$refs[errorContainer], 50)
        }, 50)
      }

      return isValid
    },
    toggle(overlayRef) {
      if (overlayRef.isOpen) {
        this.close()
      } else {
        this.open(overlayRef)
      }
    },
    open(overlayRef) {
      const owner = this
      // setTimeout to defeat the race condition in history.back and history.pushState
      window.setTimeout(() => {
        app.history.push(() => {
          const scroll = window.scrollY

          overlayRef.isOpen = false
          owner.propertySelectionOpen = false
          // setTimeout to defeat the race condition in history.back and history.pushState
          window.setTimeout(() => {
            window.scrollTo(0, scroll)
          }, 5)
        }, overlayRef)

        overlayRef.isOpen = true
        this.propertySelectionOpen = true
      }, 60)
    },
    close() {
      app.history.pop()
    },
    handleSelection(data) {
      const keyValuePair = {
        id: data.item.value,
        name: data.item.selected.toString(),
      }

      this.emitProperty(keyValuePair)
    },
    emitProperty(keyValuePair) {
      if (!this.mounted) return
      this.eventBus.emit('product-property-set-callback', keyValuePair)
    },
    emit(keyValuePair) {
      this.eventBus.emit('property-set-callback', keyValuePair)
    },
    getImages() {
      if (this.vehicleData.images && this.vehicleData.images.length > 0) {
        this.eventBus.emit(
          'images-updated',
          JSON.parse(JSON.stringify(this.vehicleData.images))
        )
      } else if (this.vehicleData.productId) {
        const owner = this
        const data = {
          productId: this.vehicleData.productId,
        }
        app.axios.post('/api/PrivateAd/GetImages/', data).then(resp => {
          if (
            resp.data.errorCollection &&
            resp.data.errorCollection.length > 0
          ) {
            owner.error(resp.data.errorCollection[0].errorMessage)
          } else {
            owner.eventBus.emit('images-updated', resp.data.data)
            owner.images = resp.data.data
          }
        })
      }
    },
  },
  watch: {
    description() {
      if (!this.mounted) return
      clearTimeout(this.descriptionTimeout)

      const owner = this
      this.descriptionTimeout = setTimeout(() => {
        const keyValuePair = {
          id: owner.vehicleData.description.id,
          name: owner.description,
        }

        owner.emit(keyValuePair)
      }, 800)

      this.descriptionErrorMessage = ''
    },
    images() {
      if (!this.mounted) return
      if (this.images.length === 0) return

      this.imageUploadErrorMessage = ''
    },
  },
  created() {
    window.scrollTo(0, 0)
    if (this.vehicleData != null) {
      if (this.vehicleData.description != null) {
        this.description =
          decodeHTMLEntities(this.vehicleData.description.name) ?? ''
      }
    }
  },
  mounted() {
    this.getImages()

    setTimeout(() => {
      this.mounted = true
    }, 200)

    if (!this.proxyBus) return
    this.eventBus.on('get-images-callback', this.getImages)
    this.proxyBus.on('private-ad-select-toggle', this.toggle)
    this.proxyBus.on('private-ad-select-close', this.close)
    this.proxyBus.on('private-ad-select-selection', this.handleSelection)

    this.eventBus.emit('stepLoaded', 3)
  },
}
</script>

<style lang="scss">
@import 'Step.scss';
</style>
